module.exports = __webpack_public_path__ + "img/banner3.679b6c7a.jpg";